import { AppComp } from './comp/AppComp'
import './css/style.css'

document.body.append(<AppComp />)
